export const MEAL_EQUIVALENT_GET_FISCAL_YEARS =
  'MEAL_EQUIVALENT_GET_FISCAL_YEARS';
export const MEAL_EQUIVALENT_LOADING = 'MEAL_EQUIVALENT_LOADING';
export const MEAL_EQUIVALENT_ERRORS = 'MEAL_EQUIVALENT_ERRORS';
export const MEAL_EQUIVALENT_GRID_CHECK_ALL = 'MEAL_EQUIVALENT_GRID_CHECK_ALL';
export const MEAL_EQUIVALENT_GRID_CHECK_ITEM =
  'MEAL_EQUIVALENT_GRID_CHECK_ITEM';
export const MEAL_EQUIVALENT_GRID_POPULATE_FIELDS =
  ' MEAL_EQUIVALENT_GRID_POPULATE_FIELDS';
export const MEAL_EQUIVALENT_GET_GRID_DATA = 'MEAL_EQUIVALENT_GET_SITES';
export const MEAL_EQUIVALENT_SET_ERROR = 'MEAL_EQUIVALENT_SET_ERROR';
export const MEAL_EQUIVALENT_WRITE_CHANGES_ERROR =
  'MEAL_EQUIVALENT_WRITE_CHANGES_ERROR';
export const MEAL_EQUIVALENT_CLEAR_ERROR = 'MEAL_EQUIVALENT_CLEAR_ERROR';
export const MEAL_EQUIVALENT_SET_SUCCESSFUL =
  'MEAL_EQUIVALENT_CLEAR_SUCCESSFUL';



// WEBPACK FOOTER //
// ./src/pages/mealequivalentsetup/state/siteequivalent/types.js